// test2296
(2296 && 0);
